import { ApprovalsResponseEmpty } from './../../models/tank-approvals-response.interface';
import { Component, computed, effect, inject, input, model, signal, ViewChild } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ApprovalsResponse } from 'src/app/models/tank-approvals-response.interface';
import { GasMeterApprovalsService } from 'src/app/services/gas-meter-approvals.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ModalTankApprovals } from '../modals/modal-tank-approvals/modal-tank-approvals';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-gas-meter-approvals',
  standalone: true,
  imports: [FontAwesomeModule, ModalTankApprovals],
  templateUrl: './gas-meter-approvals.component.html',
  styleUrl: './gas-meter-approvals.component.scss'
})
export class GasMeterApprovalsComponent {
  @ViewChild(ModalTankApprovals) modalTankApprovals!: ModalTankApprovals;
  approved = model<boolean>();
  meterId = input<number>();
  icons = inject(IconsService);
  storageService = inject(StorageService);
  gasMeterService = inject(GasMeterApprovalsService);
  approvalsResponse = signal<ApprovalsResponse[] | null>(null);
  approvalRoles = computed(() => {
    const approvals = this.approvalsResponse();
    if (approvals === null || !Array.isArray(approvals)) return [];
    return approvals.map(a => a.approver_role_id.id);
  });
  approvalBussinessUnitDirector = computed<boolean>(() => {
    return this.approvalRoles().includes(15) ? true : false;
  });
  user: any;
  roleId = signal<number>(0);

  constructor() {
    this.user = this.storageService.getItem(STORAGE_KEYS.USER) ? this.storageService.getItem(STORAGE_KEYS.USER) : null;
    this.roleId.set(this.user.role?.id ? this.user.role.id : this.user.role_id);
    effect(() => {
      const id = this.meterId();
      if (id) {
        this.loadApprovals(id);
      } else {
        this.approvalsResponse.set([]);
      }
    }, { allowSignalWrites: true })
    effect(() => {
      const approved = this.approvalBussinessUnitDirector();
      this.approved.set(this.approvalsResponse() === null ? undefined : approved);
    }, { allowSignalWrites: true })
  }

  loadApprovals(id: number) {
    this.approvalsResponse.set(null);
    this.gasMeterService.getApprovals(id)
      .subscribe({
        next: (response: ApprovalsResponse[] | ApprovalsResponseEmpty) => {
          if (this.meterId() === id) {
            if (Array.isArray(response)) {
              this.approvalsResponse.set([...response]);
            } else if (Array.isArray(response?.data) && response.data.length === 0) {
              this.approvalsResponse.set([]);
            }
          }
        },
        error: () => {
          // An unavailable approval must not grant permission to edit registration data.
        }
      });
  }

  reload() {
    const id = this.meterId();
    if (id) {
      this.loadApprovals(id);
    }
  }

  approve() {
    const modalTemplate: any | undefined = this.modalTankApprovals;
    this.modalTankApprovals.openModal(modalTemplate['modalTankApprovalsElem']);
  }
}
